module.exports = __webpack_public_path__ + "2e8ab5c53dbc18b5ad19958f3ad17f1e.MP3";